import React from 'react';
import BackgroundImage from '../components/BackgroundImage/BackgroundImage';
import blueIllustration from '../assets/blue-illustration.jpg';
import LoginForm from '../components/LoginForm/LoginForm';

const SplitSolidColorLoginForm = () => (
  <div className="container-fluid">
    <div className="row min-vh-100">
      <BackgroundImage
        backgroundColor="white"
        imageCenter={blueIllustration}
      />
      <LoginForm
        heading="Create Account"
        headingColor="white"
        subheadingColor="white"
        subheading="Enter your first name, last name, and email address below."
        backgroundColor="#0062d1"
      />
    </div>
  </div>
);

export default SplitSolidColorLoginForm;
